"use client";

import * as React from "react";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import Paper from "@mui/material/Paper";

export interface ElementSearchBoxProps {
    filter: undefined | string;
    setFilter: (filter: string) => void;
    search: (event?: React.SyntheticEvent) => void;
    working: boolean;
    placeholder: string;
    label: string;
}

export function ElementSearchBox(props: ElementSearchBoxProps) {
    const supress = (event: any) => {
        if (event.keyCode == 13) {
            event.preventDefault();
            props.search(event);
        }
    };

    return (
        <Paper component="form" sx={{ padding: "2px 4px", display: "flex", alignItems: "center", width: "100%", }}>
            <IconButton disabled={props.working} sx={{ padding: 1 }} aria-label="search" onClick={(e) => props.search(e)}>
                <SearchIcon />
            </IconButton>
            <InputBase
                sx={{ flex: 1 }}
                placeholder={props.placeholder} inputProps={{ "aria-label": props.label }}
                onKeyDown={supress} onSubmit={(e) => props.search(e)} value={props.filter}
                onChange={e => { props.setFilter(e.target.value); }}
            />
        </Paper>

    );
}